<template>
  <div class="container">
    <el-card>
      <div slot="header" class="clearfix">
        <span> {{ data.role | formatRoleName }}</span>
        <el-button v-if="showEdit" style="float: right; padding: 3px 0" type="text" @click="handleSave">保存</el-button>
        <el-button v-else style="float: right; padding: 3px 0" type="text" @click="handleEdit">编辑</el-button>
      </div>
      
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="90px" label-position="left">
        <el-form-item v-if="showEdit" prop="role" label="关系：">
          <el-select v-model="editForm.role" placeholder="请选择" size="small" style="width:170px">
            <el-option
                v-for="item in roleList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
            </el-option>
          </el-select>   
        </el-form-item>
        
        <el-form-item prop="name" label="姓名：">
          <el-input size="small" v-if="showEdit" v-model="editForm.name" style="width:170px" />
          <div style="width:85px" v-else> <strong>{{ data.data ? data.data.name : '--' }} </strong></div>
        </el-form-item>

        <div v-show="showMore" style="width: 100%; display: flex; flex-flow: row wrap;">
          <el-form-item prop="gender" label="性别：" >
            <el-select v-if="showEdit" v-model="editForm.gender" placeholder="请选择" size="small" style="width:170px">
              <el-option
                  v-for="item in genderList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
              </el-option>
            </el-select>   
            <div style="width:85px" v-else><strong> {{ data.data ? data.data.gender : '--' | formatGenderName }} </strong> </div>
          </el-form-item>

          <el-form-item prop="birthday" label="生日\年龄：">
            <el-date-picker
                v-if="showEdit"
                v-model="editForm.birthday"
                type="date"
                placeholder="选择日期时间"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width:170px"
                size="small"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            <div style="width:170px" v-else> <strong> {{ data.data ? data.data.birthday : '' | formatAge }} </strong> </div>
          </el-form-item>

          <el-form-item prop="idcard_number" label="身份证号：">
            <el-input size="small" v-if="showEdit" v-model="editForm.idcard_number" style="width:170px" />
            <div style="width:170px" v-else><strong> {{ data.data ? data.data.idcard_number : '--'  }} </strong> </div>
          </el-form-item>

          <el-form-item prop="mobile" label="手机号：">
            <el-input size="small" type="number" :controls='false' v-if="showEdit" v-model="editForm.mobile" style="width:170px" />
            <div style="width:85px" v-else> <strong>{{ data.data ? data.data.mobile : '--'  }} </strong> </div>
          </el-form-item>

          <el-form-item prop="city" label="城市：">
            <el-input size="small" v-if="showEdit" v-model="editForm.city" style="width:170px" />
            <div style="width:85px" v-else> <strong>{{ data.data ? data.data.city : '--'  }} </strong> </div>
          </el-form-item>

          <el-form-item prop="job" label="职业：">
            <el-input size="small" v-if="showEdit" v-model="editForm.job" style="width:170px" />
            <div style="width:85px" v-else><strong> {{ data.data ? data.data.job : '--'  }} </strong> </div>
          </el-form-item>
          
          <div style="width: 100%">
            <el-form-item label="健康情况：">
              <el-row v-if="showEdit" type="flex" justify="space-between">
                <el-button type="primary" size="small" @click="handleAddHealth"> 加一条 </el-button>
                <!-- <el-button type="primary" size="small"> 上传附件 </el-button> -->
              </el-row>
            </el-form-item>
            
            <el-form-item
              v-for="(item, index) in healthList"
              :key="index"
              label-width="0"
            >
              <el-row :gutter="5">
                <el-col :span="20">
                  <el-input size="small" v-if="showEdit" v-model="item.description" />
                </el-col>
                <el-col :span="4">
                  <el-button v-if="showEdit" type="danger" size="small" @click.prevent="handleRemoveHealth()">删除</el-button>
                </el-col>
              </el-row>
            </el-form-item>
            
            <div v-if="data.data && data.data.health">
              <div v-for="(item, index) in data.data.health" :key="index">
                <div v-if="!showEdit" class="health-item"> {{ item.description }}  </div>
              </div>
            </div>

          </div>

          <div style="width: 100%">
            <label class="el-form-item__label">备注：</label>
            <el-form-item prop="remark" label-width="0">
              <el-input size="small" v-if="showEdit" v-model="editForm.remark" type="textarea" :rows="3" />
            </el-form-item>
            <el-popover
              v-if="!showEdit"
              placement="bottom"
              width="500"
              trigger="hover"
              >
              <div> {{ data.data ? data.data.remark : '--'  }} </div>
              <div class="text-wrapper" slot="reference">{{ data.data ? data.data.remark : '--'  }} </div>
            </el-popover>
          </div>
        </div>
      </el-form>
      <el-button style="width: 100%;" type="text" @click="showMore = !showMore"> {{ showMore ? '收起' : '显示更多' }}</el-button>
    </el-card>

    <el-dialog 
      title="删除健康状况"
      :visible.sync="showEditForm"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleEditFormDialogClose"
    >
      <label> 选择你要删除的选项 </label>
      <el-checkbox-group v-model="delHealthList">
        <el-checkbox
          v-for="(item, index) in healthList"
          :key="index"
          :label="item.description"
          :name="index+''"
        />
      </el-checkbox-group>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditForm = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveDel"> 确 定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  const checkMobile = (rule, value, callback) => {
    if (value) {
      if (typeof(value) === String && value.length !== 11) {
        callback(new Error("手机号格式不正确"));
      }else{
        callback();
      }
    } else {
      callback();
    }
  },
  checkIdcard = (rule, value, callback) => {
    if (value) {
      if (value.length === 18) {
        callback();
      } else {
        callback(new Error("身份证号格式不正确"));
      }
    } else {
      callback();
    }
  },
  initRules = {
    role: [
      {
        required: true,
        message: "关系不能为空"
      }
    ],
    name: [
      {
        required: false,
        message: "姓名不能为空"
      }
    ],
    gender: [
      {
        required: false,
        message: "性别不能为空"
      }
    ],
    birthday: [
      {
        required: false,
        message: "生日不能为空"
      }
    ],
    job: [
      {
        required: false,
        message: "职业不能为空"
      }
    ],
    city: [
      {
        required: false,
        message: "城市不能为空"
      }
    ],
    idcard_number: [
      {
        required: false,
        message: "身份证号不能为空",
        validator: checkIdcard,
        trigger: 'blur'
      }
    ],
    mobile: [
      {
        required: false,
        message: "",
        validator: checkMobile,
        trigger: 'blur',

      },
    ],
    remark: [
      {
        required: false,
        message: "微信号不能为空"
      }
    ],
    health: [
      {
        required: false,
        message: "健康状态不能为空"
      }
    ]
  },
  initGenderList = [
    {
      value: 'm',
      label: '男'
    },
    {
      value: 'f',
      label: '女'
    },
  ],
  initRoleList = [
    {
      value: 'sp',
      label: '配偶'
    },
    {
      value: 'c',
      label: '子女'
    },
    {
      value: 'sep',
      label: '自己父母'
    },
    {
      value: 'spp',
      label: '对方父母'
    },
    {
      value: 'o',
      label: '其他'
    }
  ]

  export default {
    name: 'CustomMemberItem',
    components: {  },
    props: {
      data: {
        type: Object,
        default: function () {
          return {
            id: null,
            role: null,
            data: {
              name: null,
              gender: null,
              birthday: null,
              job: null,
              city: null,
              idcard_number: null,
              mobile: null,
              remark: null,
              health: [ 
                { 
                  description: null
                }
              ]
            }
          }
        }
      },
      showEdit: {
        type: Boolean,
        default: false
      },
      index: {
        type: Number,
        default: 0
      }
    },
    filters: {
      formatGenderName(key) {
        let ret = '--'
        let g = initGenderList.find(item => item.value === key)
        if (g) {
          ret = g.label
        }
        return ret
      },
      formatRoleName(key) {
        let ret = '--'
        let g = initRoleList.find(item => item.value === key)
        if (g) {
          ret = g.label
        }
        return ret
      },
      formatAge(date) {
        if (date) {
          let birthdays = new Date(date);
          let d = new Date();
          let age =
            d.getFullYear() -
            birthdays.getFullYear() -
            (d.getMonth() < birthdays.getMonth() ||
            (d.getMonth() == birthdays.getMonth() &&
              d.getDate() < birthdays.getDate())
              ? 1
              : 0);
          return date + ' | ' + age + '岁'
        } else {
          return '--'
        }
      }
    },
    data () {
      return {
        editForm: { ...this.data.data },
        genderList: { ...initGenderList },
        roleList: { ...initRoleList },
        healthList: [],
        delHealthList: [],
        showEditForm: false,
        showMore: false,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() >= Date.now();
          }
        }
      }
    },
    computed: {
      editRules: function () {
          return { ...initRules }
      }
    },
    created() {
      this.showMore = this.showEdit
    },
    methods: {
      handleEdit() {
        this.showMore = true
        this.editForm = { ...this.data.data}
        this.$set(this.editForm, 'role', this.data.role)
        if (this.editForm.health) {
          this.healthList = this.editForm.health
        }
        this.$emit('change-show', true, this.index)
      },
      handleSave() {
        this.$refs.editForm.validate(async valid => {
          if (valid) {
            if (this.healthList.length > 0) {
              this.editForm.health = this.healthList.filter(item => !!item.description)
            } else {
              this.editForm.health = []
            }
            if (this.editForm.mobile) {
              this.editForm.mobile = Number(this.editForm.mobile)
            }
            let data = {}
              Object.keys(this.editForm).forEach(k => {
                if (k !== 'role') {
                  data[k] = this.editForm[k]
                }
              })
            if (this.data.id && this.data.role) {
              this.$emit('change-update', {id: this.data.id, role: this.editForm.role, data: data}, this.index)
            } else {
              this.$emit('change-save',  this.editForm.role, data, this.index)
            }
          }
        })
      },
      handleAddHealth() {
        this.healthList.push({description: null })
      },
      handleRemoveHealth() {
        this.showEditForm = true
      },
      handleSaveDel() {
        if (this.healthList.length > 0) {
          this.healthList = this.healthList.filter(item => this.delHealthList.indexOf(item.description) < 0)
        }
        this.showEditForm = false
        this.handleSave()
      },
      handleEditFormDialogClose() {
        this.$refs.editForm.clearValidate()
      }
    }
  }
</script>
<style scoped>

.el-form-item {
  margin-bottom: 1px;
  margin-right: 10px;
}
.is-error {
  margin-bottom: 15px;
}

.text-wrapper {
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
  line-height: 1.5;
  display: -webkit-box;
  overflow-wrap: break-word;
}
.el-form {
  display: flex;
  flex-flow: row wrap;
}
.health-item {
  border-radius: 2px;
  border: 1px solid #ddd6d6;
  padding: 2px 5px;
  margin-bottom: 5px;
}
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type='number'] {
  -moz-appearance: textfield !important;
}

</style>